import logo from './logo.svg';
import './App.css';
import Keyboard from './components/Keyboard';

function App() {
  return (
    <div className="App">
      <Keyboard />
    </div>
  );
}

export default App;
